import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../analytics";

// Scrolls window to top whenever the route pathname changes
// and fires a page_view analytics event.
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    trackPageView(pathname + search);
  }, [pathname, search]);
  return null;
};

export default ScrollToTop;
